module.exports = __webpack_public_path__ + "img/resort-02.b37243e2.jpg";